import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import moment from 'moment';
import { Guid } from './entities';

@Injectable()
export class ReportService {
    static serviceName: string;
    constructor() {
        ReportService.serviceName = `${environment.serviceName}/report`;
    }

    openSalesReport(filter) {
        const reportName = 'SalesReport';
        const qsInvoiceId = `&invoiceId=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&invoiceId=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }

    openMsrpReport(orderLineDetailIds: number[]) {
        let queryParams = orderLineDetailIds.map(id => `orderLineDetailIds=${id}`).join('&');
        const url = `${ReportService.serviceName}/msrpReport?${queryParams}`;
        window.open(url, '_blank');
    }

    openSalesReportWithGuid(filter) {
        const reportName = 'SalesReportWithGuid';
        const qsInvoiceId = `&invoiceId=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&invoiceId=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }


    openInvoiceReport(filter) {
        const reportName = 'InvoiceWithBalanceReport';
        const qsInvoiceId = `&invoiceId=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&invoiceId=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }

    openInvoiceWithBalanceReport(filter) {
        const reportName = 'InvoiceWithBalanceReport';
        const qsInvoiceId = `&invoiceId=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&invoiceId=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }

    openInvoiceReportWithGuid(filter) {
        const reportName = 'InvoiceReportWithGuid';
        const qsInvoiceId = `&invoiceId=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&invoiceId=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }


    openPartDetailReport(filter: any, topLevelOnly?: boolean) {
        const reportName = 'PartDetailReport';
        let queryString = `&partId=${filter}`;
        if (topLevelOnly) queryString = queryString + `&topLevelPartsOnly=${topLevelOnly}`
        const url = `${ReportService.serviceName}/${reportName}?${queryString}`;
        window.open(url, '_blank');
    }

    openPurchaseOrderReport(filter) {
        const reportName = 'PurchaseOrderReport';
        const qsId = `&id=${filter}`;

        const url = `${ReportService.serviceName}/${reportName}?${qsId}`;
        window.open(url, '_blank');
    }

    openPurchaseOrderAuditReport(filter) {
        const reportName = 'PurchaseOrderAuditReport';
        const qsId = `&id=${filter}`;

        const url = `${ReportService.serviceName}/${reportName}?${qsId}`;
        window.open(url, '_blank');
    }

    openPackingSlip(filter) {
        const reportName = 'PackingSlipReport';
        const qsInvoiceId = `&id=${filter}`;

        let qsInvoiceIds = '';
        filter.map(invoiceId => {
            qsInvoiceIds = `${qsInvoiceIds}&id=${invoiceId}`;
        });

        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceIds}`;
        window.open(url, '_blank');
    }
    printDeliveryReport(deliveryId: number) {
        const reportName = 'DeliveryReport';
        const qsInvoiceId = `id=${deliveryId}`;



        const url = `${ReportService.serviceName}/${reportName}?${qsInvoiceId}`;
        window.open(url, '_blank');
    }

    printAssemblySchedule(filter) {
        const reportName = 'AssemblySchedule';
        // console.log(moment(filter.runDate).startOf('week').toDate())
        // const startDate = moment(filter.runDate).startOf('week').format('MM/DD/YYYY');
        // const endDate = moment(moment(filter.runDate).endOf('week').toDate()).format('MM/DD/YYYY');
        // console.log(endDate);

        let queryStringIds = '';
        filter.ids.map(x => {
            queryStringIds = `${queryStringIds}&id=${x}`;
        });
        queryStringIds = `${queryStringIds}&mode=${filter.mode}`;

        const url = `${ReportService.serviceName}/${reportName}?${queryStringIds}`;
        window.open(url, '_blank');
    }

    printAssemblyJigSchedules(date: Date, printWeek?: boolean, jigIds?: number[]) {
        const startDate = moment(date).format('MM/DD/YYYY');
        const queryParams = [`date=${startDate}`];
        if (printWeek) queryParams.push(`printWeek=${printWeek}`);
        console.log(jigIds);
        if (!!jigIds && jigIds.length > 0){

            let queryStringIds = '';
            jigIds.map(x => {
                queryStringIds = `${queryStringIds}&jigIds=${x}`;
            });

            queryParams.push(queryStringIds);
        } 
        window.open(`${ReportService.serviceName}/AssemblyJigSchedule?${queryParams.join('&')}`, '_blank');
    }

    gotoUPSAccount() {
        const url = `https://www.ups.com/us/en/Home.page`;
        window.open(url, '_blank');
    }

    printBuildAssemblyReport(assemblyId: number) {
        const reportName = 'BuildAssemblyReport';
        const url = `${ReportService.serviceName}/${reportName}?id=${assemblyId}`;
        window.open(url, '_blank');
    }

    printVendorPickUp(purchaseOrderPickUpId: number) {
        const reportName = 'PurchaseOrderPickUpReport';
        const url = `${ReportService.serviceName}/${reportName}?id=${purchaseOrderPickUpId}`;
        window.open(url, '_blank');
    }

    printConfirmation(code: Guid) {
        const url = `${ReportService.serviceName}/confirmationReport?code=${code}`;
        window.open(url, '_blank');
    }

    printAchAuthFormReport(code: Guid) {
        const url = `${ReportService.serviceName}/achAuthFormReport?code=${code}`;
        window.open(url, '_blank');
    }
}
